var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlluStatusCube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.138,
    height: 163,
    viewBox: "0 0 149.138 163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_3803",
    x: 0,
    y: 70,
    width: 149.138,
    height: 93,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4d95fc",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_3802",
    x: 25.708,
    y: 26.197,
    width: 97.719,
    height: 63.592,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_3806",
    x: 27.235,
    y: 91.527,
    width: 94.669,
    height: 41.262,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_3807",
    x: 27.222,
    y: 69.197,
    width: 94.696,
    height: 42.068,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Linie_98",
    x: 102.824,
    y: 49.449,
    width: 20,
    height: 61,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Linie_99",
    x: 64.324,
    y: 70.449,
    width: 20,
    height: 61,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Linie_100",
    x: 64.324,
    y: 27.449,
    width: 20,
    height: 61,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Linie_101",
    x: 26.324,
    y: 49.449,
    width: 20,
    height: 61,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cube",
    transform: "translate(-9.176 -15.551)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.18, 15.55)",
    filter: "url(#Pfad_3803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3803-2",
    "data-name": "Pfad 3803",
    d: "M18.176,129.745,83.828,166.55l65.486-36.805L83.828,91.55Z",
    transform: "translate(-9.18 -15.55)",
    fill: "#0057ff",
    fillRule: "evenodd",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3804",
    "data-name": "Pfad 3804",
    d: "M18.176,129.745,83.828,166.55l65.486-36.805L83.828,91.55Z",
    fill: "#0057ff",
    fillRule: "evenodd",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3805",
    "data-name": "Pfad 3805",
    d: "M17.3,54.254l1.278,75.3,65.249-38,66.359,38.7v-76L83.829,15.55Z",
    fill: "#0057ff",
    fillRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.18, 15.55)",
    filter: "url(#Pfad_3802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3802-2",
    "data-name": "Pfad 3802",
    d: "M45.9,70.951,83.793,92.194l37.8-21.243-37.8-22.045Z",
    transform: "translate(-9.18 -15.55)",
    fill: "none",
    stroke: "#0057ff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.18, 15.55)",
    filter: "url(#Pfad_3806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3806-2",
    "data-name": "Pfad 3806",
    d: "M45.9,113.951l37.893,21.243,37.8-21.243",
    transform: "translate(-9.18 -15.55)",
    fill: "none",
    stroke: "#0057ff",
    strokeWidth: 2,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.18, 15.55)",
    filter: "url(#Pfad_3807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3807-2",
    "data-name": "Pfad 3807",
    d: "M121.59,113.951l-37.8-22.045L45.9,113.951",
    transform: "translate(-9.18 -15.55)",
    fill: "none",
    stroke: "#0057ff",
    strokeWidth: 2,
    strokeDasharray: "4 4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.18, 15.55)",
    filter: "url(#Linie_98)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_98-2",
    "data-name": "Linie 98",
    y2: 43,
    transform: "translate(112.82 55.45)",
    fill: "none",
    stroke: "#0057ff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.18, 15.55)",
    filter: "url(#Linie_99)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_99-2",
    "data-name": "Linie 99",
    y2: 43,
    transform: "translate(74.32 76.45)",
    fill: "none",
    stroke: "#0057ff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.18, 15.55)",
    filter: "url(#Linie_100)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_100-2",
    "data-name": "Linie 100",
    y2: 43,
    transform: "translate(74.32 33.45)",
    fill: "none",
    stroke: "#0057ff",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.18, 15.55)",
    filter: "url(#Linie_101)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_101-2",
    "data-name": "Linie 101",
    y2: 43,
    transform: "translate(36.32 55.45)",
    fill: "none",
    stroke: "#0057ff",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluStatusCube);
export default __webpack_public_path__ + "static/media/illu-status-cube.4ea74e6c612d14bcfd97b0c0ef3f7b28.svg";
export { ForwardRef as ReactComponent };